import styled from 'styled-components'
import {spacing} from '../../../../../theme/spacing'

export const Logo = styled.div`
    margin-right: ${spacing(10)};
    width: 214px;
    height: 46px;
`
